import { Box, Card } from '@zillow/constellation-10';
import { LoadingImage, LoadingText } from '@zg-rentals/loading-components';

export function DocumentCardSkeleton() {
  return (
    // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- Constellation has no output component
    <Box role="status" aria-label="Loading file">
      <Card
        elevated={false}
        tone="soft"
        body={
          <>
            <LoadingImage isLoading loadingWidth="100%" loadingHeight="96px" />
            <LoadingText isLoading loadingWidth="60%" textStyle="fineprint-bold">
              Loading
            </LoadingText>
          </>
        }
      />
    </Box>
  );
}
